import React, { useState, useEffect } from 'react';
import { getOrderStats } from '../services/orders';
import { getOrders } from '../services/orders';
import StatsCards from '../components/Dashboard/StatsCards';
import RecentOrders from '../components/Dashboard/RecentOrders';
import Charts from '../components/Dashboard/Charts';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import toast from 'react-hot-toast';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsData, ordersData] = await Promise.all([
        getOrderStats(),
        getOrders({ limit: 10, page: 1 })
      ]);
      setStats(statsData.stats);
      setRecentOrders(ordersData.data || []);
    } catch (error) {
      console.error('Dashboard error:', error);
      toast.error('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Dashboard</h1>
      
      <StatsCards stats={stats} />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <Charts stats={stats} />
        <RecentOrders orders={recentOrders} />
      </div>
    </div>
  );
}
